import React from 'react';
import { Users, Lightbulb, UsersRound } from 'lucide-react';
import './WhyCultureMatters.css';

const WhyCultureMatters = () => {
  const benefits = [
    {
      icon: Users,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #7C3AED 100%)',
      title: 'Boost Retention',
      description: 'Reduce turnover costs and retain your most valuable asset: your people.'
    },
    {
      icon: Lightbulb,
      gradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
      title: 'Enhance Innovation',
      description: 'A positive culture encourages creativity and new ideas from every level.'
    },
    {
      icon: UsersRound,
      gradient: 'linear-gradient(135deg, #9C4DF4 0%, #3B82F6 100%)',
      title: 'Improve Collaboration',
      description: 'Foster environments where teams work together seamlessly and effectively.'
    }
  ];

  return (
    <section className="why-culture-matters section">
      <div className="container">
        <div className="why-culture-header">
          <h2 className="section-title">Why Culture Transformation Matters Now</h2>
          <p className="section-description">
            In today's dynamic business landscape, a healthy culture isn't just a perk—it's a strategic imperative. High retention, engaged teams, and boosted productivity are direct outcomes of intentional culture building.
          </p>
        </div>
        
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <div key={index} className="benefit-card">
                <div className="benefit-icon" style={{ background: benefit.gradient }}>
                  <IconComponent size={28} strokeWidth={2.5} />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyCultureMatters;
